<script lang="ts">
  import { page } from '$app/stores';
  import { getNavbarLayoutContext } from '$lib/client/layout/Navbar.svelte';
  import IconChevronDown from '~icons/tabler/chevron-down';
  import IconChevronRight from '~icons/tabler/chevron-right';
  import IconStar from '~icons/tabler/star';
  import IconPlus from '~icons/tabler/plus';
  import IconEye from '~icons/tabler/eye-plus';
  import Tooltip from '$lib/client/Tooltip.svelte';

  interface Category {
    id: number;
    title: string;
    slug: string;
    parentId: number | null;
    createdAt: Date;
    updatedAt: Date;
    children: Category[];
    _count?: {
      auctions: number;
    };
  }

  interface PageData {
    authUser: any;
    currentCategory?: Category;
    parentCategory?: Category;
    categories: Category[];
  }

  let openCategoryId: number | undefined;

  $: pageData = $page.data as PageData;
  $: isLoggedIn = !!pageData.authUser;
  $: currentCategoryId = pageData.currentCategory?.id;
  $: parentCategoryId = pageData.parentCategory?.id;
  $: if (openCategoryId === undefined) {
    openCategoryId = parentCategoryId ?? currentCategoryId;
  }
  $: categories = pageData.categories;

  // @ts-expect-error
  $: closeMenu = getNavbarLayoutContext()?.closeMenu;

  function toggleCategory(id: number) {
    openCategoryId = id === openCategoryId ? undefined : id;
  }
</script>

<aside>
  <nav aria-label="categories">
    {#if isLoggedIn}
      <div class="d-flex align-items-center gap-3 mb-3">
        <a
          href="/auctions/favorites"
          class="btn btn-sm my-favorites d-flex align-items-center gap-2"
          style="width: max-content;"
          on:click={closeMenu}
        >
          <IconStar />
          <span>My Favorites</span>
        </a>

        <a
          href="/backoffice/my-selling/new"
          class="d-flex gap-1 btn btn-sm btn-primary align-items-center"
          style="font-size: 0.75rem"
        >
          <IconPlus style="font-size: 0.75em;" />
          <span>Add New Sales</span>
        </a>
      </div>
    {/if}
    <span class="fs-7 fw-bold">Categories</span>

    <ul class="list-unstyled py-2 fs-7">
      {#if categories}
        {#each categories as cat (cat.id)}
          {@const isOpen = openCategoryId === cat.id}
          {@const isCurrent = currentCategoryId === cat.id}
          <li class="mb-3" style="max-width: max-content">
            <div class="list-unstyled d-flex align-items-center gap-1">
              <button type="button" class:invisible={cat.children.length === 0} on:click={() => toggleCategory(cat.id)}>
                {#if isOpen}
                  <IconChevronDown style="font-size: 0.875em; margin-bottom: 2px;" aria-hidden="true" />
                {:else}
                  <IconChevronRight style="font-size: 0.875em; margin-bottom: 3px;" aria-hidden="true" />
                {/if}
              </button>

              {#if cat.children?.length === 0}
                <a href={`/auctions/${cat.slug}`} class="link-dark text-decoration-none">
                  <span class:fw-bolder={isCurrent}>{cat.title}</span>
                </a>
              {:else}
                <button class="link-dark" on:click={() => toggleCategory(cat.id)}>
                  <span class:fw-bolder={isCurrent}>{cat.title}</span>
                </button>
              {/if}
            </div>

            {#if isOpen}
              <ul class="list-unstyled mt-2" style="margin-left: 2rem;">
                {#each cat.children as subCat (subCat.id)}
                  {@const isCurrentSubCat = currentCategoryId === subCat.id}
                  <li class="mb-2 d-flex align-items-center gap-2">
                    <a href={`/auctions/${cat.slug}/${subCat.slug}`} class="link-dark" on:click={closeMenu}>
                      <span class:fw-bolder={isCurrentSubCat}>{subCat.title}</span>
                      <span class="fs-8 text-secondary">({subCat._count?.auctions ?? '?'})</span>
                    </a>
                    <Tooltip>
                      <a slot="trigger" href={`/backoffice/account/notifications`} class="link-secondary">
                        <IconEye />
                      </a>
                      <p>Add category to watchlist</p>
                    </Tooltip>
                  </li>
                {/each}
              </ul>
            {/if}
          </li>
        {/each}
      {/if}
    </ul>
  </nav>
</aside>

<style>
  button {
    z-index: 10;
  }

  .my-favorites {
    border: 1px solid var(--bs-gray-300);
    color: var(--bs-gray-800);
  }

  .my-favorites:hover {
    background: var(--bs-gray-100);
  }
</style>
